module.exports = __webpack_public_path__ + "img/shared-5.d86796f5.jpg";